<template>
    <div class="p-1 noselect d-flex align-items-center">
        <font-awesome-icon :icon="name" :size="size" />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: [String, Array],
            required: true,
        },
        size: {
            type: String,
            default: 'xs',
        },
    },
};
</script>
